module.exports = __webpack_public_path__ + "static/media/logo-코어트러스트@2x.407463b5.png";